<template>
  <span class="multilang-input">
    <div v-for="(lang, index) in displayLanguages" :key="lang" class="lang-wrapper">
      <div v-if="languages.length > 1 && !noLanguageIndicator" class="language-indicator bg-light .text-dark px-2 border"><span>{{ lang.toUpperCase() }}</span></div>
      <div class="language-input">
        <slot
        :index="index"
        :lang="lang"
        :langName="getLanguageName(lang)"
        :value="(value || {})[lang]"
        :input="(val) => setValue(lang, val)"
        :props="(langProps || {})[lang]"
      >
        <b-form-input
          v-bind="(langProps || {})[lang]"
          :value="(value || {})[lang]"
          @input="setValue(lang, $event)"
        ></b-form-input>
      </slot>
      </div>
    </div>
  </span>
</template>
<script>
import { languages } from "@/languages.js";

export default {
  props: {
    value: Object,
    languages: Array,
    langProps: Object,
    noLanguageIndicator: Boolean
  },
  computed: {
    displayLanguages() {
      return this.languages ?? (this.value ? Object.keys(this.value) : []);
    },
  },
  methods: {
    setValue(lang, val) {
      const newValue = { ...this.value, [lang]: val }
      if (val == null) delete newValue[lang]
      this.$emit("input", newValue);
    },
    getLanguageName(lang) {
      return languages.find((l) => l.code == lang)?.nativeName;
    },
  },
};
</script>
<style lang="scss" scoped>

.lang-wrapper {
  display: flex;
  align-items: stretch;

  & ~ & {
    margin-top: .25rem;
  }
}

.language-indicator {
  width: 2.6em;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: light;
  margin-right: -1px;
}


.language-input {
  width: 100%;
}


</style>